import { formatFullDate } from "@/filters/date";

export default [
  {
    filter: formatFullDate,
    filterName: "formatFullDate",
  },
];
